<template>
    <div class="yy-select-member-search scroll-content-horizonal" ref="scrollContent">
        <Collapse v-if="member.length">
            <template slot="title">
                {{t('selectMember.member')}}
            </template>
            <template slot="content">
                <MemberNode 
                    v-for="(item, index) in member"
                    :key="index"
                    :data="item"
                    @handleChecked="handleChecked" />
            </template>
        </Collapse>
        <Collapse v-if="dept.length">
            <template slot="title">
                {{t('selectMember.dept')}}
            </template>
            <template slot="content">
                <DeptNode 
                    v-for="(item, index) in dept"
                    :key="index"
                    :data="item"
                    :withMembers="false"
                    :showExpand="false"
                    @handleChecked="handleChecked" />
            </template>
        </Collapse>
        <Collapse v-if="group.length">
            <template slot="title">
                {{t('selectMember.group')}}
            </template>
            <template slot="content">
                <GroupNode 
                    v-for="(item, index) in group"
                    :data="item"
                    :key="index"
                    :withMembers="false"
                    @handleChecked="handleChecked"/>
            </template>
        </Collapse>
        <Collapse v-if="team.length">
            <template slot="title">
                {{t('selectMember.team')}}
            </template>
            <template slot="content">
                <TeamNode 
                    v-for="(item, index) in group"
                    :data="item"
                    :key="index"
                    :withMembers="false"
                    @handleChecked="handleChecked"/>
            </template>
        </Collapse>
        <Load 
            :hasData="!!(member.length || dept.length || group.length || team.length)"
            :hasMore="hasMore"
            :loading="loading" 
            @on-load="getMemberList"/>
        <Empty type="nosearch" v-if="!loading && !hasMore && !(member.length || dept.length || group.length || team.length)"/>
    </div>
</template>
<script>
    import DeptNode from './section/section-dept-node'
    import GroupNode from './section/section-group-node'
    import TeamNode from './section/section-team-node'
    import MemberNode from './section/section-member-node'
    import Collapse from '../../base/collapse'
    import Empty from '../../base/empty/'
    import ajax from '../../../utils/ajax'
    import Load from '../../base/page/'
    import scroll from './mixins/scroll'
    import Locale from '../../../mixins/locale'

    export default {
        mixins: [scroll, Locale],
        inject: ['root'],
        data() {
            return {
                member: [],
                dept: [],
                group: [],
                team: [],
                loading: false,
                hasMore: true
            }
        },
        components: {
            DeptNode,
            GroupNode,
            TeamNode,
            MemberNode,
            Collapse,
            Empty,
            Load
        },
        methods: {
            getMemberList(resolve) {
                const _this = this
                const deptIds = this.root.deptList && this.root.deptList.map((item)=>{
                    return item.deptId
                }) || []
                ajax({
                    url: `${this.root.host}/cooperation/rest/v1/candidate/${this.root.qzId}/members`,
                    params: {
                        page: 1,
                        size: 10,
                        keyword: _this.root.keyword || '',
                        deptIds: [...deptIds],
                        type: _this.root.chooseType,
                        language: _this.root.language
                    },
                    success(res) {
                        let data = JSON.parse(res)
                        if(!Array.isArray(data)) {
                            resolve({ member: [] })
                        }

                        data.forEach(item => {
                            item.checked = false
                        })

                        resolve({ member: data })
                    },
                    error() {
                        resolve({ member: [] })
                    }
                })
            },
            getDeptList(resolve) {
                const _this = this
                ajax({
                    url: `${this.root.host}/cooperation/rest/v1/candidate/${this.root.qzId}/0/depts`,
                    params: {
                        withMembers: 0,
                        keyword: _this.root.keyword,
                        language: _this.root.language
                    },
                    success(res) {
                        let data = JSON.parse(res)
                        if(!Array.isArray(data)) {
                            resolve({ dept: [] })
                        }
                        data.forEach(item => {
                            item.checked = false
                            item.haveSub = 0
                            item.userNum = 0
                        })
                        resolve({ dept: data })
                    },
                    error() {
                        resolve({ dept: [] })
                    }
                })
            },
            getGroupList(resolve) {
                const _this = this
                ajax({
                    url: `${this.root.host}/cooperation/rest/v1/candidate/${this.root.qzId}/groups`,
                    params: {
                        keyword: _this.root.keyword,
                        page: 1,
                        size: 10,
                        language: _this.root.language
                    },
                    success(res) {
                        let data = JSON.parse(res)
                        if(!Array.isArray(data)) {
                            resolve({ group: [] })
                        }
                        data.forEach(item => {
                            item.checked = false
                        })
                        resolve({ group: data })
                    },
                    error() {
                        resolve({ group: [] })
                    }
                })
            },
            getTeamList(resolve) {
                const _this = this
                ajax({
                    url: `${this.root.host}/cooperation/rest/v1/candidate/${this.root.qzId}/team/list`,
                    params: {
                        keyword: _this.root.keyword,
                        page: 1,
                        size: 10,
                        language: _this.root.language
                    },
                    success(res) {
                        let data = JSON.parse(res)
                        if(!Array.isArray(data)) {
                            resolve({ team: [] })
                        }
                        data.forEach(item => {
                            item.type = 4
                            item.checked = false
                        })
                        resolve({ team: data })
                    },
                    error() {
                        resolve({ team: [] })
                    }
                })
            },
            handleChecked(checked, data) {
                data.checked = checked
                this.$emit('handleSelected', data)
            },
            initSearch() {
                const tabs = this.root.tabs
                this.root.handleSearch = () => {
                    this.member = []
                    this.dept = []
                    this.group = []
                    this.team = []
                    if(!this.root.keyword.trim()) {
                        return this.root.insearch = false
                    }
                    this.updateScroll()
                    this.loading = true
                    this.hasMore = true
                    const tabsFun = [
                        {
                            key: 'member',
                            fun: ()=>{
                                return new Promise(resolve=>{
                                    this.getMemberList(resolve)
                                })
                            }
                        },
                        {
                            key: 'dept',
                            fun: ()=>{
                                return new Promise(resolve=>{
                                    this.getDeptList(resolve)
                                })
                            }
                        },
                        {
                            key: 'group',
                            fun: ()=>{
                                return new Promise(resolve=>{
                                    this.getGroupList(resolve)
                                })
                            }
                        },
                        {
                            key: 'team',
                            fun: ()=>{
                                return new Promise(resolve=>{
                                    this.getTeamList(resolve)
                                })
                            }
                        }
                    ]
                    const searchFun = tabsFun.filter((item)=>{
                        return tabs.indexOf(item.key) != -1
                    }).map(item=>{ return item.fun() })
                    this.root.insearch = true
                    Promise.all(searchFun).then((res)=>{
                        res.forEach(item=>{
                            const key = Object.keys(item)[0]
                            this[key] = item[key]
                        })
                        this.loading = false
                        this.hasMore = false
                    })
                }
            }
        },
        created() {
            this.initSearch()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/business/select-member/search.vue